import { type FC, useMemo } from "react";

import { useAppContext } from "@/shared/hooks/useAppContext";
import { useEstateItemActions } from "@/shared/hooks/useEstateItemActions";
import { ModuleReviewLayout } from "@/pages/postloss/modules/components/ModuleReviewLayout";
import type { FlowCustomComponentProps } from "@/shared/constants/flowTypes";
import type { EstateItem } from "@/shared/types/estateTypes";

const OTHER_ASSET_CATEGORIES = [
  "Receivables",
  "Work-related pay and shares",
  "Royalties and Intellectual Property",
  "Prepaid Services and Credits",
];

export const OtherAssetsReview: FC<FlowCustomComponentProps> = ({ onComplete, goToScreen }) => {
  const estateId = useAppContext().person?.estate_id;
  const { assets, isLoading, updateItem, isUpdatingItem, deleteItem, isDeletingItem } =
    useEstateItemActions(estateId);

  const sections = useMemo(() => {
    const grouped: Record<string, EstateItem[]> = {};
    for (const item of assets) {
      if (OTHER_ASSET_CATEGORIES.includes(item.category)) {
        if (!grouped[item.category]) grouped[item.category] = [];
        grouped[item.category].push(item);
      }
    }
    return OTHER_ASSET_CATEGORIES.filter((cat) => grouped[cat]?.length).map((cat) => ({
      label: cat,
      items: grouped[cat],
    }));
  }, [assets]);

  return (
    <ModuleReviewLayout
      sections={sections}
      isLoading={isLoading}
      onComplete={() => onComplete()}
      onAdd={() => goToScreen("other_assets_checklist")}
      addLabel="Add an asset"
      showAddButton
      estateId={estateId}
      updateItem={updateItem}
      isUpdatingItem={isUpdatingItem}
      deleteItem={deleteItem}
      isDeletingItem={isDeletingItem}
    />
  );
};
